
  export default {
    props: {
      links: {
        type: Array,
        required: true,
      },
    },
  };
